import React from "react"
import ReactFlow, {
  Controls,
  MiniMap,
  Background,
  BackgroundVariant,
} from "react-flow-renderer"
import "gantt-task-react/dist/index.css"
import { ReactangleNode } from "./CustomNode"
import "./customNodeStyle.css"
import dagre from "dagre"
import { createUseStyles } from "react-jss"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import {
  flowDiagramADFLinkSelector,
  flowDiagramAsync,
  flowDiagramDataSelector,
  flowDiagramStatusSelector,
  gantActiveSelector,
  setParentNode,
} from "../MonitorSlice"
import { Box, CircularProgress } from "@mui/material"
import ADF from "../../../icons/adf.svg"
const nodeTypes = {
  rectangle: ReactangleNode,
}
const useStyles = createUseStyles({
  wrapper: {
    borderRadius: "4px",
    border: "2px solid #E6ECF0",
    height: 210,
    marginTop: 10,
  },
  miniMapHeight: {
    height: 42,
  },
})
export const ReactFlowDiagram: any = () => {
  const dispatch = useAppDispatch()
  const jobs: any = useAppSelector(flowDiagramDataSelector)
  const classes = useStyles()
  const allUniqueNodes: any = []
  const allEdges: any = []
  const position = { x: 0, y: 0 }
  // eslint-disable-next-line
  const activeGantSelection = useAppSelector(gantActiveSelector)
  // eslint-disable-next-line
  const flowDiagramStatus = useAppSelector(flowDiagramStatusSelector)
  // eslint-disable-next-line
  const adfLink = useAppSelector(flowDiagramADFLinkSelector)
  if (jobs === null || jobs === undefined) {
    return
  }
  jobs.forEach((job: any) => {
    const sourceNode: any = {}
    const desNode: any = {}
    const edge: any = {}
    let nodeName

    sourceNode.id = job.source_node.id.toString()
    sourceNode.type = "rectangle"
    sourceNode.position = position

    nodeName = job.source_node
    sourceNode.data = {
      nodeName,
    }

    allUniqueNodes.push(sourceNode)

    desNode.id = job.destination_node.id.toString()
    desNode.type = "rectangle"
    desNode.position = position

    nodeName = job.destination_node
    desNode.data = {
      nodeName,
    }

    allUniqueNodes.push(desNode)

    edge.source = job.source_node.id.toString()
    edge.target = job.destination_node.id.toString()
    edge.type = "straight"
    edge.markerStart = { type: "arrowclosed", color: "#F6BB42" }
    edge.markerEnd = { type: "arrowclosed", color: "#F6BB42" }
    edge.id = job.id
    edge.style = { stroke: "#F6BB42" }
    allEdges.push(edge)
  })

  // --------------------------------------------DAGREE ----------------------------------------------

  const dagreGraph = new dagre.graphlib.Graph()
  dagreGraph.setDefaultEdgeLabel(() => ({}))

  const nodeWidth = 330
  const nodeHeight = 200

  const getLayoutedElements = (nodes: any, edges: any, direction = "LR") => {
    dagreGraph.setGraph({ rankdir: direction })

    nodes.forEach((node: any) => {
      dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight })
    })

    edges.forEach((edge: any) => {
      dagreGraph.setEdge(edge.source, edge.target)
    })

    dagre.layout(dagreGraph)

    nodes.forEach((node: any) => {
      const nodeWithPosition = dagreGraph.node(node.id)

      node.position = {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      }

      return node
    })

    return { nodes, edges }
  }

  const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(
    allUniqueNodes,
    allEdges,
  )
  const nodes = layoutedNodes
  const edges = layoutedEdges

  return (
    <div
      className={`w-[95%] min-h-[85%] m-auto mt-6 border border-blurbackground rounded-lg ${classes.wrapper}`}
    >
      {flowDiagramStatus === "loading" ? (
        <Box className="flex h-full items-center justify-center">
          <CircularProgress />
        </Box>
      ) : (
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          fitView
          onNodeClick={(event: React.MouseEvent, node: any) => {
            if (node.data.nodeName.type === "ExecutePipeline") {
              dispatch(
                flowDiagramAsync({
                  reference_pipeline: node.data.nodeName.run.reference_pipeline,
                }),
              )
              dispatch(setParentNode(activeGantSelection["extra"]["name"]))
            }
          }}
        >
          <MiniMap nodeColor={"#F8BEBE"} className={classes.miniMapHeight} />
          <Controls fitViewOptions={{ maxZoom: 5 }} />
          <Box
            className="border-gray-200 border ml-1"
            sx={{
              marginLeft: "auto",
              border: "1px solid rgb(226, 24, 36)",
              borderRadius: "7px",
              padding: "2px",
              height: "23px",
              width: "31px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              left: 10,
              top: 10,
              cursor: "pointer",
              zIndex: 100,
            }}
          >
            {adfLink ? (
              <a href={adfLink} target="blank">
                <img src={ADF} alt="" />
              </a>
            ) : (
              ""
            )}
          </Box>
          <Background
            variant={BackgroundVariant.Lines}
            gap={30}
            className={"lines"}
          ></Background>
        </ReactFlow>
      )}
    </div>
  )
}
